<template>
  <div class="ticket1 flex jc-center">
    <!--<img class="bgimg" src="../../../static/img_zs_bg.png" alt="">-->
    <div class="bgimg">
      <div class="tkl-collegename tc">
        <div class="tkl-names">
          {{ detail.collegeName }}
        </div>
      </div>
      <div class="tc title-type">{{ detail.resultTitle ? detail.resultTitle : '校考合格证' }}</div>
      <div class="tk-line2">
        <div class="tk-line2-border">
          <div id="qrcode" ref="qrcode" class="qr-code"></div>
          <div class="pb8 flex jc-between mb-8">
            <img class="txl-photo mr-8 ml-8" :src="imgUrls" crossorigin="anonymous">
            <div style="flex: 1;">
              <div class="name mb-8">{{ detail.examineeName }}</div>
              <div class="custom cm-tip" v-if="!Tool.isNull(detail.examineeSex)">
                <div class="cm-label">性别</div>
                <div class="brake-all cm-content">
                  <template v-if="detail.examineeSex == 1">
                    男
                  </template>
                  <template v-if="detail.examineeSex == 0">
                    女
                  </template>
                </div>
              </div>
              <div v-if="!Tool.isNull(detail.areaName)">
                <div v-if="detail.areaName && detail.areaName.length < 5" class="custom cm-tip">
                  <div class="cm-label">{{detail.isOverseas == 1 ? "报考地区" : "高考省份"}}</div>
                  <div class="brake-all cm-content">{{ detail.areaName }}</div>
                </div>
                <div v-else class="custom cm-tip">
                  <div>
                    <div class="mb-8">{{detail.isOverseas == 1 ? "报考地区" : "高考省份"}}</div>
                    <div class="brake-all">{{ detail.areaName }}</div>
                  </div>
                </div>
              </div>
              <div v-if="detail.examineeNo" class="custom cm-tip">
                <div class="cm-label">考生号</div>
                <div class="brake-all cm-content">{{ detail.examineeNo }}</div>
              </div>
              <div v-if="detail.idType" class="custom cm-tip">
                <div>
                  <div class="mb-8">{{idTypeList[detail.idType]}}</div>
                  <div class="brake-all">{{ detail.examineeIdNo }}</div>
                </div>
              </div>
              <div v-else class="custom cm-tip">
                <div>
                  <div class="mb-8">证件号</div>
                  <div class="brake-all">{{ detail.examineeIdNo }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- showStyle (integer, optional): 展示样式 1-显示名次 2-显示分数 3-分数/名次都显示 4-仅显示是否通过 , -->
          <div class="brake-all pl-8 pr-8 special-info">
            <div class="border-line"></div>
            <div class="hege-cell">
              <div class="hc-label">
                <img class="hc-icon" src="../../../static/icon_zy.png" alt="">
                通过专业
              </div>
              <div class="hc-content">
                {{ detail.specialtyName }}
              </div>
            </div>
            <template v-if="[3,1].includes(detail.showStyle)">
              <div class="border-line"></div>
              <div class="hege-cell">
                <div class="hc-label">
                  <img class="hc-icon" src="../../../static/icon_pm.png" alt="">
                  排名
                </div>
                <div class="hc-content">
                  {{ detail.rank }}
                </div>
              </div>
            </template>
            <template v-if="[3,2].includes(detail.showStyle)">
              <div class="border-line"></div>
              <div class="hege-cell">
                <div class="hc-label">
                  <img class="hc-icon" src="../../../static/icon_fs.png" alt="">
                  分数
                </div>
                <div class="hc-content">
                  {{ detail.scoreText }}分
                </div>
              </div>
            </template>
            <div class="border-line"></div>
           <div class="hege-cell mb-8 certificateExtraContent" style="display: block;">
             <div v-html="detail.certificateExtraContent" v-if="detail.certificateExtraContent"></div>
             <div class="tr" style="margin-top: 20px; font-size: 14px; color: #434345;" v-if="detail.resultPublishDesc">{{ detail.resultPublishDesc }}</div>
           </div>
            <img class="bg-hege" src="../../../static/icon_hege.png" alt="">
          </div>
          <!-- <div class="he-zm">*本合格证仅用作参与复试的证明，不可作其他用途*</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tool from '@/utils/tools'
import QRCode from 'qrcodejs2'
import {Toast} from 'vant'
import ApiInfo from "@/apis/api-info";
import * as _localStorage from "@/utils/storage";

export default {
  props: ['detail'],
  data() {
    return {
      Tool,
      imgUrls: require('../../../static/img_ktx.png'),
      collegeLogoUrl: '',
      idTypeList: {
        1:'身份证号',
        2:'护照号',
        3:'通行证号',
        4:'证件号'
      }
    }
  },
  created() {
    this.getFormatLogo()
    // this.getInfo()
    this.detail.certificateExtraContent = this.detail.certificateExtraContent.replace(/\n/g, '<br>')
  },
  mounted() {
    this.setQrcode()
  },
  methods: {
    setQrcode() {
      let qrcodeObj = this.$refs.qrcode;
      new QRCode(qrcodeObj, {
        text: this.detail.qrCode
      })
    },
    async getInfo() {
      const collegeId = _localStorage.getStorageSync('collegeId')
      const res = await ApiInfo.getExamResult(collegeId)
      console.log(res);
    },
    async getFormatLogo() {
      Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      })
      try {
        if (this.detail.officialPhoto) {
          this.imgUrls = await this.getImgBase64(this.detail.officialPhoto)
        }
        this.collegeLogoUrl = await this.getImgBase64(
            this.detail.collegeLogoUrl + '?' + Date.now()
        )
        Toast.clear()
      } catch (error) {
        Toast.clear()
      }
    },
    image2Base64(img) {
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, img.width, img.height)
      var dataURL = canvas.toDataURL('image/png')
      return dataURL
    },
    getImgBase64(image) {
      return new Promise((resolve, reject) => {
        var img = new Image()
        img.crossOrigin = '*'
        img.src = image
        img.onload = () => resolve(this.image2Base64(img))
        img.onerror = reject
      })
    },
  },
}
</script>
<style lang="less" scoped>
// 合格证
.ticket1 {
  width: 100%;
  // height: 499px;
  padding: 4px;
  background: rgba(170, 64, 59);
  //border-radius: 8px;
  //box-shadow: 0px 4px 24px rgba(0, 18, 54, 0.06);
  position: relative;
  min-height: 100%;
  //border-radius: 6px;
  //background-color: #fff;
  //border: 1px solid #d9d9d9;
}

.bgimg {
  background-color: #ffffff;
  width: 100%;
  //height: 100%;
  //min-height: calc(100vh - 100px);
  //display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;

  .title-type {
    background-color: #AA403B;
    color: #fff;
    padding-bottom: 8px;
  }
}

.qr-code {
  position: absolute;
  width: 81px;
  height: 81px;
  right: 0px;
  border-left: 1px solid #aa403b;
  border-bottom: 1px solid #aa403b;
  z-index: 9;

  /deep/ img {
    width: 80px !important;
    height: 80px !important;
  }

  /deep/ canvas {
    width: 80px !important;
    height: 80px !important;
  }
}

.bg-hege {
  position: absolute;
  width: 90px;
  height: 105px;
  right: 0px;
  top: 0px;
  //bottom: 135px;
}

.tk-line2 {
  //position: absolute;
  //left: 0;
  //top: 0;
  width: 100%;
  //height: 100%;
  //height: calc(100vh - 292px);
  z-index: 10;
  //width: 0;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  //padding: 32px;

  .tk-line2-border {
    margin: 6px;
    border: 1px solid #AA403B;
    //height: -webkit-fill-available;
    position: relative;
    min-height: 97.5%;

    .special-info {
      position: relative;
      min-height: 260px;
    }

    .pb8 {
      padding-top: 8px;
    }
  }
}

.tk-logo {
  display: flex;
  justify-content: center;
  align-items: center;

  .tkl-circle2 {
    width: 40px;
    height: 40px;
    border: 2px solid #aa403b;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tkl-circle1 {
    width: 34px;
    height: 34px;
    border: 1px solid #aa403b;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tkl-img {
    width: 30px;
    height: 30px;
    border-radius: 100%;
  }
}

.tkl-collegename {
  width: 100%;
  background: #AA403B url('../../../static/img_fgx@2xnew.png') no-repeat center;
  background-size: 100% 14px;
  padding: 0 36px;
  //background-color: #AA403B;
}

.tkl-names {
  //background: rgba(170, 64, 59, 1);
  min-height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  word-break: break-all;
  color: #fff;
  padding: 4px 10px;
  //background: url('../../../static/1.png') no-repeat center;
  background-size: 100% 100%;
  //filter: opacity(0.6);
  // color: #FDFCFA;
  font-size: 20px;
}

.border-line {
  width: 100%;
  height: 1px;
  background: rgba(170, 64, 59, 0.39);
}

.txl-photo {
  width: 91px;
  height: 129px;
  background: #f5f5f5;
  border-radius: 4px;
  object-fit: contain;
}

.name {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 600;
  color: #972427;
  max-width: 120px;
  word-break: break-all;
}

.custom {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #434345;
}

.cm-tip {
  display: flex;
  margin-bottom: 8px;
}

.cm-label {
  //width: 50px;
  margin-right: 8px;
}

.cm-content {
  flex: 1;
}

.red-rank {
  color: #b71c25;
}

.gp-text {
  font-size: 10px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 16px;
  color: #434345;
}

.hege-cell {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  min-height: 38px;
  font-family: PingFang SC;
  color: #434345;
}

.certificateExtraContent{
  padding-top: 8px;
  white-space: pre-wrap;
  //min-height: 130px;
}

.hc-label {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 88px;
}

.hc-content {
  flex: 1;
}

.hc-icon {
  width: 12px;
  height: 14px;
  object-fit: contain;
  margin-right: 4px;
}

.he-zm {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 30px;
  font-size: 8px;
  font-family: PingFang SC;
  line-height: 34px;
  color: rgba(170, 64, 59, 0.45);
  text-align: center;
  // letter-spacing: 120px;
}
</style>
